import React from 'react'

const Kanban = () => {
  return (
    <div>
      
    </div>
  )
}

export default Kanban
